import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { EventService } from "../../event-service/event.service";

export abstract class BaseIntegration {
  private eventService: EventService;
  private http: HttpClient;

  constructor(eventService: EventService, http: HttpClient) {
    this.eventService = eventService;
    this.http = http;
  }

  public create(inst: any) {
    const url = this.url(inst.notice);
    return this.http
      .post(url, inst)
      .pipe(
        map((data: any) => {
          this.eventService.publish("issue:created", {
            issue: data,
            serviceName: this.serviceName(),
          });
          if (this.afterCreate != null) {
            this.afterCreate(data, inst);
          }
          return inst;
        }),
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return of(error);
        }),
      );
  }

  public get(notice: any) {
    const url = this.url.apply(notice, arguments);
    return this.http.get(url);
  }

  public destroy(inst: any) {
    this.eventService.publish("issue:deleted", {
      groupId: inst.notice.groupId,
      serviceName: this.serviceName(),
    });
    const url = this.url(inst.notice);
    return this.http.delete(url);
  }

  protected abstract serviceName(): string;
  protected abstract url(notice: any): string;
  protected abstract afterCreate(data: any, inst: any): any;
}
